import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnalyticsClick } from '@com-delta-idp/mnx-skymiles-shared';
import { Benefits } from '../../models/benefits.interfaces';

@Component({
  selector: 'idp-goodies',
  templateUrl: './goodies.component.html',
  styleUrls: ['./goodies.component.scss']
})
export class GoodiesComponent {
  @Input() content: Benefits = {} as Benefits;
  @Input() index = 0;
  @Output() clickAnalyticsEvent = new EventEmitter<AnalyticsClick>();

  updateClickEvent(link: string) {
    const clickData: AnalyticsClick = {
      id: 'tile1' + (this.index + 1),
      type: 'tile',
      position: this.index + ' of ' + this.content.stacks.length,
      source: 'page content',
      name: this.content.stacks[+this.index].tier + ' ' + link,
      sub_type: '',
      title: this.content.title,
      membership_tier: this.content.stacks[+this.index].tier
    };
    this.clickAnalyticsEvent.emit(clickData);
  }
}
